/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect, useState} from 'react';
import {motion} from "motion/react";
import {Database} from "../APIClient.jsx";
import {Socket} from "../Socket.js";
import {useSub} from "subscription";
import {UI} from "../UIGenerator.jsx";
import {Deployments} from "../Objects/Deployments.jsx";
import ElementStatus from "./ElementStatus.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";

const ActiveDeployments = () => {
    const [deployments, setDeployments] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let result = await Deployments().listRunning();
                setDeployments(result?.deployments ?? []);
            } catch (err) {
                console.error("Error fetching running deployments:", err);
            }
        };
        fetchData();
    }, []);

    useSub(() => Database.table("Deployments", "app").onChange((change) => {
        setDeployments(prev => Socket.applyChange(prev, change));
    }, []), "liveActiveDeploymentsData");

    return (
        <div className={"gap-3 flex flex-wrap"}>
            {deployments.filter(deployment => deployment.status === "running").map(deployment => {
                return (
                    <motion.div
                        key={deployment.indexKey}
                        layout
                        onClick={() => {
                            UI.page().navigate({pathname: "/d/" + deployment.indexKey})
                        }}
                        className="group bg-white rounded-xl border border-gray-100 shadow-sm p-3 flex items-center gap-3 cursor-pointer hover:border-blue-200"
                    >
                        <div className={"flex-shrink-0 p-2 flex justify-center items-center rounded-lg bg-zinc-50 border"}>
                            <DisplayIcon iconName={"Deployment"} size={"1.1rem"}/>
                        </div>

                        <div className={"min-w-0"}>
                            <div className={"text-sm font-medium text-gray-900 truncate"}>
                                {deployment.userInput?.name ?? deployment.indexKey}
                            </div>
                            <div className={"text-xs text-gray-400"}>
                                {deployment.objectType}
                            </div>
                        </div>

                        <div className={"flex-shrink-0 ml-2"}>
                            <ElementStatus name={"Deployments"} elementId={deployment.indexKey}/>
                        </div>
                    </motion.div>
                );
            })}
        </div>
    );
}

export default ActiveDeployments;